module.exports = __webpack_public_path__ + "img/8.5674c9a2.png";